"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[859],{

/***/ 859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Quotes; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useKeyDown-88662051.mjs
var useKeyDown_88662051 = __webpack_require__(403);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
// EXTERNAL MODULE: ../wif-ui-lib/dist/VideoIcon-c13b94d3.mjs
var VideoIcon_c13b94d3 = __webpack_require__(3652);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Quotes.js





const d = "quotes", p = "quotes__content", x = "quote", _ = "desktop", f = "quote__image", T = "quote__text-container", E = "quote__text", C = "quote__reference-text", t = {
  quotes: d,
  quotesContent: p,
  quote: x,
  desktop: _,
  quoteImage: f,
  quoteTextContainer: T,
  quoteText: E,
  quoteReferenceText: C
};
function B({ quotes: a }) {
  return /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B, { className: t.quotes, "data-testid": "quotes" }, /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { className: t.quotesContent }, a.map((o, n) => /* @__PURE__ */ react.createElement(g, { key: o.id || n, ...o }))));
}
function g({
  text: a,
  referenceText: o,
  iconVideoSrc: n,
  iconFallbackImgSrc: r,
  iconAltText: m,
  className: q,
  ...l
}) {
  return /* @__PURE__ */ react.createElement(
    "blockquote",
    {
      className: (0,useKeyDown_88662051.c)(q, t.quote),
      ...l,
      "data-testid": "quote"
    },
    /* @__PURE__ */ react.createElement(
      "div",
      {
        role: "presentation",
        className: t.quoteImage,
        title: m,
        "data-testid": "quote-image"
      },
      /* @__PURE__ */ react.createElement(VideoIcon_c13b94d3.V, { src: n, fallbackImgSrc: r })
    ),
    /* @__PURE__ */ react.createElement("div", { className: t.quoteTextContainer, "data-testid": "quote-content" }, /* @__PURE__ */ react.createElement(
      "p",
      {
        className: (0,useKeyDown_88662051.c)(t.quoteText, useKeyDown_88662051.t.textsComponentTitleBold)
      },
      a
    ), o && /* @__PURE__ */ react.createElement(
      "p",
      {
        className: (0,useKeyDown_88662051.c)(
          t.quoteReferenceText,
          useKeyDown_88662051.t.textsLeadText
        )
      },
      o
    ))
  );
}

//# sourceMappingURL=Quotes.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Quotes/Quotes.tsx





function Quotes(props) {
    var isPreview = (0,router.useRouter)().isPreview;
    var quotes = (0,react.useMemo)(function() {
        return (0,magnolia/* jcrMultiFieldToArray */.FE)(props.quotes).map(function(quote) {
            return mapQuoteNodeToQuoteUI(quote, isPreview);
        });
    }, [
        props.quotes,
        isPreview
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(B, {
            quotes: quotes
        })
    });
}
function mapQuoteNodeToQuoteUI(quote) {
    var isPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        id: quote["@id"],
        text: quote.text,
        referenceText: quote.referenceText,
        iconAltText: quote.iconAltText,
        iconVideoSrc: (0,magnolia/* getAssetPath */.K3)(quote.video, isPreview),
        iconFallbackImgSrc: (0,magnolia/* getAssetPath */.K3)(quote.image, isPreview)
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/Quotes/index.ts
/* istanbul ignore file */ 


/***/ })

}]);